// Per-hostname configuration for the Israel patient app.
//
// The Israel app talks to TWO backends (both exposed here so future features
// can call either): the Israel backend and the (psy-)clinic backend. The pair
// is chosen from the current hostname, defaulting to the dev values.
//
// Env overrides (build time):
//   REACT_APP_IL_BACKEND_URL   overrides israelBackendBaseUrl
//   REACT_APP_IL_CLINIC_URL    overrides clinicBackendBaseUrl

export interface IsraelConfig {
  israelBackendBaseUrl: string;
  clinicBackendBaseUrl: string;
}

const DEV_CONFIG: IsraelConfig = {
  israelBackendBaseUrl: 'https://dev-backend.taliaz-cm.com',
  clinicBackendBaseUrl: 'https://dev-psyclinic-back.taliaz-cm.com/api/v1',
};

const PROD_CONFIG: IsraelConfig = {
  // The Israel backend has no dedicated prod deployment; the prod app uses the
  // test-backend as its production API.
  israelBackendBaseUrl: 'https://test-backend.taliaz-cm.com',
  clinicBackendBaseUrl: 'https://api-psy.taliaz-cm.com/api/v1',
};

// When running the frontend locally, hit the Israel backend on local port 8002
// (and the psy-clinic backend on its local port 8001).
const LOCAL_CONFIG: IsraelConfig = {
  israelBackendBaseUrl: 'http://localhost:8002',
  clinicBackendBaseUrl: 'http://localhost:8001/api/v1',
};

const CONFIG_BY_HOSTNAME: Record<string, IsraelConfig> = {
  'dev-my.taliaz-cm.com': DEV_CONFIG,
  'my.taliaz-cm.com': PROD_CONFIG,
  localhost: LOCAL_CONFIG,
  '127.0.0.1': LOCAL_CONFIG,
};

export function getIsraelConfig(): IsraelConfig {
  let base: IsraelConfig = DEV_CONFIG;
  try {
    const hostname = window.location.hostname.toLowerCase();
    base = CONFIG_BY_HOSTNAME[hostname] || DEV_CONFIG;
  } catch {
    // window may be unavailable; fall back to dev defaults.
  }

  return {
    israelBackendBaseUrl:
      process.env.REACT_APP_IL_BACKEND_URL || base.israelBackendBaseUrl,
    clinicBackendBaseUrl:
      process.env.REACT_APP_IL_CLINIC_URL || base.clinicBackendBaseUrl,
  };
}
